import { ReactNode } from 'react';

import { Group, Text } from '@mantine/core';

/**
 * One line of a completed section's data summary — dot-separated facts,
 * never a bare header (Baymard: collapsed accordion steps must carry
 * their data).
 */
export function SummaryRow({ parts }: Readonly<{ parts: ReactNode[] }>) {
  const visible = parts.filter((p) => p !== null && p !== undefined && p !== '');
  return (
    <Group gap={6} wrap="wrap">
      {visible.map((part, i) => (
        <Group key={i} gap={6} wrap="nowrap">
          {i > 0 && (
            <Text size="sm" c="dimmed">
              ·
            </Text>
          )}
          {typeof part === 'string' || typeof part === 'number' ? (
            <Text size="sm">{part}</Text>
          ) : (
            part
          )}
        </Group>
      ))}
    </Group>
  );
}
